import { DeclarationCustomer } from '../common/declaration-customer';
import { Declaration, Notifiable, Amendable } from '../declaration';
import { DeclarationExternalEntity } from '../enums/common/declaration-external-entity';
import { DeclarationInternalType } from '../enums/common/declaration-internal-type';
import { IrelandEnsNotification } from './entry-summary-notification';

export const ensNameLabels = [
    {
        key: 'ENS',
        value: 'ENS (Entry Summary Declaration)',
    },
];

export interface IrelandEntrySummaryDeclarationPayload extends Declaration {
    declarationExternalEntity: DeclarationExternalEntity.REVENUE;
    declarationInternalType: DeclarationInternalType.ENS;
    isCoreTemplate?: boolean;
    entrySummaryDeclaration?: IrelandEntrySummaryDeclaration;
}
export interface IrelandEntrySummaryDeclaration extends Amendable, Notifiable<IrelandEnsNotification> {
    id?: string;
    issuing?: Issuer;
    numberOfItems?: number;
    totalNumberOfPackages?: number;
    totalGrossMass?: number;
    personLodgingTheSummaryDeclaration?: DeclarationCustomer; // Representative
    carrier?: DeclarationCustomer;
    agent?: DeclarationCustomer;
    goodsShipment?: GoodsShipment;
    specificCircumstanceIndicator?: string;
}

export interface GoodsShipment {
    id?: string;
    ucr?: string;
    firstEntryCustomsOffice?: CustomOffice;
    entryCustomsOffice?: CustomOffice[];
    consignment?: Consignment;
    goodsItems?: EnsGoodsShipmentItem[];
    transportMethodOfPaymentCode?: string;

    consignor?: DeclarationCustomer;
    consignee?: DeclarationCustomer;
    notifyParty?: DeclarationCustomer;
}

export interface Issuer {
    place?: string;
}

export interface CustomOffice {
    id?: string;
    referenceNumber?: string;
    expectedDateTimeArrival?: string;
}

export interface BorderTransportMeans {
    identityCrossingBorder?: string;
    nationalityCrossingBorder?: string;
    conveyanceReferenceNumber?: string;
    transportMode?: number;
    itinerary?: Itinerary[];
}

export interface Itinerary {
    countryOfRoutingCode: string;
}

export interface Packaging {
    marks?: string;
    type?: string;
    numberOfPackages?: number;
    numberOfPieces?: number;
}

export interface TransportEquipment {
    sealsIdentity?: string;
}

export interface EnsGoodsShipmentItem {
    id?: string;
    ucr?: string;
    commodityCodeField?: string;
    transportChargesMethodOfPayment?: string;
    itemNumber?: number;
    loadingPlace?: string;
    unloadingPlace?: string;
    grossMass?: number;
    commodity?: Commodity;

    consignor?: DeclarationCustomer;
    consignee?: DeclarationCustomer;
    notifyParty?: DeclarationCustomer;

    goodsPackaging?: Packaging[];

    borderTransportMeans?: BorderTransportMeans[];
    additionalDocument?: AdditionalInfo[];
    additionalInformation?: AdditionalInfo[];

    transportEquipment?: Container[];
}

export interface AdditionalInfo {
    code?: string;
    identifier?: string;
}

export interface Container {
    equipmentIdentification?: string;
}

export interface SubsequentNumber {
    subsequentCustomsNumber?: string;
}

export interface Consignment {
    borderTransportMeans?: BorderTransportMeans;
    inlandModeOfTransport?: string;
    locationOfGoods?: string;
    loadingPlace?: string;
    unloadingPlace?: string;
    transportEquipment?: TransportEquipment[];
}

export interface Commodity {
    description?: string;
    dangerousCode?: string;
    combinedNomenclature?: string;
}
